import React, { useEffect, useState } from "react";
import { httpclient } from "../../../../utils/httpClient.js";
import { Grid, Snackbar, styled } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import ViewNetsuiteCarrierDetails from "./ViewNetsuiteCarrierDetails/index.js";
import NetsuiteCarrierTable from "./NetsuiteCarrierTable";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Header = styled("div")(({ theme }) => ({
  "& h1": {
    color: theme.palette.primary.dark,
    margin: "0",
  },
}));

const NetsuiteCarriers = () => {
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState([]);
  const [carrierName, setCarrierName] = useState("");
  const [singleLoading, setSingleLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageState, setMessageState] = useState("");

  useEffect(() => {
    getCurrentCarriers();
  }, []);

  const getCurrentCarriers = () => {
    setLoading(true);
    httpclient
      .get(`/netsuite/v1/getCarriers`)
      .then(({ data }) => {
        if (data.success) {
          setRows(data.records.data); 
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          localStorage.clear();
          window.location = "/login";
        }
        setLoading(false);
      });
  };

  const handleView = (nsID, name) => {
    setSingleLoading(true);
    setOpenViewDialog(true);
    setCarrierName(name);
    httpclient
      .get(`/netsuite/v1/getCarrierDetail/${nsID}`)
      .then(({ data }) => {
        if (data.success) {
          setViewDetails(data.records);
          setSingleLoading(false);
        }
      })
      .catch((err) => {
        setSingleLoading(false);
        setViewDetails([]);
        setMessage("Error fetching carrier details");
        setMessageState("error");
        setOpen(true);
      });
  };

  const sendDetails = (callback) => {
    if (callback.open === false) {
      setOpenViewDialog(false);
      setViewDetails([]);
      setCarrierName("");
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <Header>
            <h1>List Carriers (NetSuite)</h1>
          </Header>
        </Grid>
        <Grid item xs={12}>
          <NetsuiteCarrierTable
            rows={rows}
            loading={loading}
            handleView={handleView}
          />
        </Grid>
      </Grid>
      {openViewDialog && (
        <ViewNetsuiteCarrierDetails
          singleLoading={singleLoading}
          viewDetails={viewDetails}
          carrierName={carrierName}
          sendDetails={sendDetails}
        />
      )}
      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={messageState} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NetsuiteCarriers;